import * as React from 'react';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import {Button} from '@mui/material';
import Grid from '@mui/material/Grid';
import {useSelector} from 'react-redux';
import {RootState} from '../../../../redux/store';
import ButtonStyle from '../../../../styles/buttonStyle/buttonStyle';
import config from '../../../../config/index';

function copyLink(link: string) {
  const textArea = document.createElement('textarea');
  document.body.appendChild(textArea);
  textArea.value = link;
  textArea.select();
  document.execCommand('copy');
  document.body.removeChild(textArea);
}

interface AffiliateLinkProps {
  book_url: string;
}

const AffiliateLink = ({book_url}: AffiliateLinkProps) => {
  const {code = null} = useSelector((state: RootState) => state.user);

  const base_url = config.REACT_APP_TERTULIA_WEB_URL? config.REACT_APP_TERTULIA_WEB_URL:'';

  const affiliateCode = code ? `affiliate_id=${code}` : '';

  const linkAffiliate = book_url ? `${base_url}${book_url}?${affiliateCode}` : '';

  return (
    <Grid
      container
      display="flex"
      direction="row"
      alignItems="center"
      spacing={1}>
      <Grid item>
        <b>Product link : </b> {linkAffiliate}
      </Grid>
      <Grid item>
        <ButtonStyle>
          <Button onClick={() => copyLink(linkAffiliate)} size="small">
            <ContentCopyIcon />
          </Button>
        </ButtonStyle>
      </Grid>
    </Grid>
  );
};

export default AffiliateLink;
